module.exports = __webpack_public_path__ + "static/media/install-interstate-battery-red.e7b5f2e3.svg";